import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Downloads.css';

function Downloads() {
  return (
    <div className="downloads-page">
      <Helmet>
        <title>Downloads - Audra Books</title>
        <meta name="description" content="Download Audra Books for iOS and Android, or ShelfPulse for iOS." />
        <link rel="canonical" href="https://audrabooks.app/downloads" />
      </Helmet>
      <div className="downloads-container">
        <header className="downloads-header">
          <h1>Downloads</h1>
          <p className="downloads-subtitle">Get Audra Books and ShelfPulse on your devices</p>
        </header>

        <div className="apps-grid">
          {/* Audra Books iOS */}
          <div className="app-card">
            <h2>Audra Books for iOS</h2>
            <p className="app-description">
              Audiobook and ebook player for Audiobookshelf
            </p>
            <a
              href="https://apps.apple.com/us/app/audra-books/id6756032522"
              className="download-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              App Store
            </a>
          </div>

          {/* Audra Books Android */}
          <div className="app-card">
            <h2>Audra Books for Android</h2>
            <p className="app-description">
              Audiobook and ebook player for Audiobookshelf
            </p>
            <a
              href="https://play.google.com/store/apps/details?id=com.randallresort.audra"
              className="download-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Play
            </a>
          </div>

          {/* ShelfPulse iOS */}
          <div className="app-card">
            <h2>ShelfPulse for iOS</h2>
            <p className="app-description">
              Stats tracker for Audiobookshelf
            </p>
            <a
              href="https://apps.apple.com/us/app/shelfpulse/id6754263899"
              className="download-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              App Store
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Downloads;
